"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const oaf_routing_1 = require("oaf-routing");
exports.defaultSettings = Object.assign(Object.assign({}, oaf_routing_1.defaultSettings), { 
    // TODO support pop page state restoration.
    restorePageStateOnPop: false, 
    // We're not restoring page state ourselves so leave this enabled.
    disableAutoScrollRestoration: false });
exports.wrapRouter = (router, settingsOverrides) => {
    const settings = Object.assign(Object.assign({}, exports.defaultSettings), settingsOverrides);
    const oafRouter = oaf_routing_1.createOafRouter(settings, location => location.hash);
    /**
     * https://router.vuejs.org/api/#router-onready
     * This method queues a callback to be called when the router has completed the initial navigation,
     * which means it has resolved all async enter hooks and async components that are associated with
     * the initial route.
     */
    router.onReady(() => {
        // HACK Allow DOM updates to happen before we repair focus.
        setTimeout(() => {
            oafRouter.handleFirstPageLoad(router.currentRoute);
        }, settings.renderTimeout);
    });
    const unregister = router.afterEach((to, from) => {
        // HACK Allow DOM updates to happen before we repair focus.
        setTimeout(() => {
            oafRouter.handleLocationChanged(from, to, undefined, undefined);
        }, settings.renderTimeout);
    });
    return () => {
        oafRouter.resetAutoScrollRestoration();
        unregister();
    };
};
